import { AppThunk } from '../../../store/rootReducer';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import * as diagnosticActions from '../actions/diagnostic.actions';
import * as diagnosticClient from '../clients/diagnostic.client';
import { definitionsLoadedSelector } from '../selectors/diagnostic.selectors';
import { Definition } from '../types/diagnostic';
import { separateDefinitions } from '../utils/abnormalities.util';

export const loadDefinitions = (): AppThunk => async (dispatch, getState) => {
  const definitionsLoaded = definitionsLoadedSelector(getState());
  const hasAutoDiagnostic = booleanPreferenceSelector('autoDiagnostic')(
    getState(),
  );

  if (definitionsLoaded) {
    return;
  }

  const allDefinitions = await diagnosticClient.getDefinitions();

  if (allDefinitions != null) {
    let primaryDefinitions: Definition[] = [];
    let definitions: Definition[] = [];

    if (hasAutoDiagnostic) {
      [primaryDefinitions, definitions] = separateDefinitions(allDefinitions);
    } else {
      definitions = [...allDefinitions];
    }

    dispatch(
      diagnosticActions.setDefinitions({
        definitions: definitions,
        primaryDefinitions: primaryDefinitions,
        meta: { history: false },
      }),
    );
  }
};
